import React from "react";

function Lock({ ratio = 16 }) {
  return (
    <svg
      width={ratio}
      height={ratio}
      aria-hidden="true"
      focusable="false"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.16251 14H10.8451C11.6176 14 12 13.6018 12 12.743V8.29278C12 7.53547 11.7017 7.12947 11.0822 7.0514V5.4743C11.0822 3.06962 9.53728 2 8 2C6.47035 2 4.91777 3.06962 4.91777 5.4743V7.09044C4.35946 7.20755 4 7.59792 4 8.29278V12.743C4 13.6018 4.38241 14 5.16251 14ZM6.02676 5.31036C6.02676 3.81133 6.96749 3.06962 8 3.06962C9.03251 3.06962 9.98088 3.81133 9.98088 5.31036V7.04359L6.02676 7.0514V5.31036Z"
        fill="#B5B5B5"
      />
    </svg>
  );
}

export default Lock;
